<template>
    <MainContent title="Crear producto">
        <template v-slot:header>
            <h3 class="card-title pb-3">Crear producto</h3>
        </template>
        <template v-slot:content v-if="!loading">
            <FormComponent
                :producto="producto"
                :error="error"
                @terminado="crearProducto()"
                @imagenBorrada="{ error = null }"
            />
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent";
    import FormComponent from '@/components/backend/productos/FormComponent';

    export default {
        data() {
            return {
                loading: false,
                producto: {
                    filters: {},
                    name: '',
                    description: '',
                    imagen: ''
                },
                error: null
            }
        },
        methods: {
            crearProducto() {
                this.loading = true;
                this.producto.category_id = this.producto.categoria?.id;
                if(this.producto.subir_imagen){
                    this.producto.imagen = this.producto.subir_imagen
                }

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.productos.crear'), this.producto).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.productos.index' });
                }).catch(error => {
                    this.$toast.error('Ha ocurrido un error');
                    this.error = error.response?.data?.errors?.imagen[0];
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        components: {
            MainContent, FormComponent
        }
    }
</script>
